import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StoreState, StatsigExperimentsConfig } from '@statsig/statsig.entities';
import { userExperiments } from '@statsig/store/statsig.selectors';

@Injectable()
export class StatsigExperimentsFacade {
  constructor(private store: Store<StoreState>) { }

  public userExperiments$: Observable<StatsigExperimentsConfig[]> = this.store.pipe(select(userExperiments));

  public specificExperiment$(specificExperiment: string): Observable<StatsigExperimentsConfig> {
    return this.userExperiments$.pipe(
      map(experiments => experiments.find(experiment => experiment.name === specificExperiment))
    );
  }

  public experimentTreatmentOn$(specificExperiment: string): Observable<boolean> {
    return this.specificExperiment$(specificExperiment).pipe(
      map(split => split?.treatment as boolean));
  }

}
